import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { key: { type: String, default: "details-state" } }

  connect() {
    const saved = localStorage.getItem(this.keyValue)
    if (saved === "closed") {
      this.element.removeAttribute("open")
    }
    this.element.addEventListener("toggle", this.save)
  }

  disconnect() {
    this.element.removeEventListener("toggle", this.save)
  }

  save = () => {
    localStorage.setItem(this.keyValue, this.element.open ? "open" : "closed")
  }
}
